import { defineComponent as _defineComponent } from 'vue'
interface Props {
  menuItem?: any;
  isActive?: boolean;
  isParent?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterMainMenuItem',
  props: {
    menuItem: { default: () => ({}) },
    isActive: { type: Boolean, default: false },
    isParent: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})